import { AritoIcon, AritoFormV2, BottomActionBarV2, DialogV2, HeaderTabsV2 } from '@/components/custom/erp';
import { BasicInfoTab, GeneralTab, OtherTab } from './tabs';
import { SearchFormValues, searchSchema } from '../schema';
import { UseSearchFieldStatesReturn } from '../hooks';
import { useReportContext } from '../context';

interface InitialSearchDialogProps {
  onClose: () => void;
  onSearch: (values: SearchFormValues) => Promise<void>;
  initialValues: SearchFormValues;
  searchFieldStates: UseSearchFieldStatesReturn;
}

export default function SearchDialog({
  onClose,
  onSearch,
  initialValues,
  searchFieldStates
}: InitialSearchDialogProps) {
  const { setExportSubtitle } = useReportContext();
  const { state } = searchFieldStates;
  const handleSubmit = (data: SearchFormValues) => {
    const formatLabel = (value?: string) => {
      if (!value) return '';
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return '';
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    };

    const formattedFrom = formatLabel(data.ngay_ct1);
    const formattedTo = formatLabel(data.ngay_ct2);
    setExportSubtitle(formattedFrom && formattedTo ? `Từ ngày ${formattedFrom} đến ngày ${formattedTo}` : '');

    const combinedData: SearchFormValues = {
      ...data,
      ma_nv: state.nhanVien?.uuid || '',
      ma_kh: state.khachHang?.uuid || '',
      nh_kh1: state.nhomKhachHang1?.uuid || '',
      nh_kh2: state.nhomKhachHang2?.uuid || '',
      nh_kh3: state.nhomKhachHang3?.uuid || '',
      rg_code: state.khuVuc?.uuid || '',

      ma_vt: state.vatTu?.uuid || '',
      nh_vt1: state.nhomVatTu1?.uuid || '',
      nh_vt2: state.nhomVatTu2?.uuid || '',
      nh_vt3: state.nhomVatTu3?.uuid || '',
      ma_kho: state.khoHang?.uuid || '',

      ma_gd: state.giaoDich?.uuid || '',
      tk_vt: state.taiKhoanVatTu?.uuid || '',
      tk_dt: state.taiKhoanDoanhThu?.uuid || '',
      tk_gv: state.taiKhoanGiaVon?.uuid || '',
      ma_lo: state.lo?.uuid || '',
      ma_vi_tri: state.viTri?.uuid || ''
    };
    onSearch(combinedData);
  };

  const tabs = [
    {
      id: 'details',
      label: 'Chi tiết',
      component: <GeneralTab searchState={searchFieldStates} />
    },
    {
      id: 'other',
      label: 'Khác',
      component: <OtherTab searchState={searchFieldStates} />
    }
  ];

  return (
    <DialogV2
      open={true}
      onClose={onClose}
      title='Báo cáo mua hàng nhóm theo 2 chỉ tiêu'
      titleIcon={<AritoIcon icon={699} />}
      maxWidth='lg'
    >
      <div className='flex size-full flex-col overflow-hidden'>
        <div className='max-h-[calc(100vh-120px)] flex-1 overflow-auto'>
          <AritoFormV2<SearchFormValues>
            schema={searchSchema}
            initialData={initialValues}
            onSubmit={handleSubmit}
            className='!static !w-full'
            hasAritoActionBar={false}
            headerFields={
              <div className='max-h-[calc(100vh-150px)] w-[800px] min-w-[800px] overflow-y-auto'>
                <BasicInfoTab />

                <HeaderTabsV2 tabs={tabs} />
              </div>
            }
            bottomBar={<BottomActionBarV2 mode='search' onClose={onClose} />}
          />
        </div>
      </div>
    </DialogV2>
  );
}
